<template>
  <div class="bespread-wrap module-layer4">
    <div class="screen-container">
      <div class="cnt">
        <div class="layer-box-cnt">
          <div
            class="pic-num"
            :class="[
              'pic' + pItem.id,
              boxIndex == pItem.id ? 'box-active' : 'box-unactive'
            ]"
            v-for="pItem in boxList"
            :key="pItem.id"
          >
            <div 
              class="pic-box"
              :class="'pic-box' + pItem.id"
              v-if="boxIndex != pItem.id"
              @click="handlePic(pItem)"
              @mouseenter="handlePicMouse(pItem)"
              @mouseleave="handlePicLeave(pItem)"

            >
              <img
                :src="
                  mouseIdx == pItem.id
                    ? require('../../assets/img/layer4/' +
                        lang +
                        '/pic-cnt-active-' +
                        pItem.id +
                        '.png')
                    : require('../../assets/img/layer4/' +
                        lang +
                        '/pic-cnt-' +
                        pItem.id +
                        '.png')
                "
                class="sl-cnt"
              />
              <div class="sl_car"></div>
            </div>
            <div
              class="sl-box"
              :class="['sl-box' + pItem.id]"
              v-if="boxIndex == pItem.id"
            >
              <img
                :src="
                  require('../../assets/img/layer4/' +
                    lang +
                    '/pic-title-' +
                    pItem.id +
                    '.png')
                "
                class="sl-title"
              />
            </div>
          </div>
        </div>
        <div class="layer-line-cnt">
          <div class="botton-icon">
            <div
              v-for="(item, idx) in navList"
              :key="idx"
              class="icon"
              @click="handleIcon(item)"
            >
              <img 
              :src="iconIndex == item.id 
              ? require('../../assets/img/layer4/' +
                        lang +
                        '/menu-' +
                        item.id +
                        '-active.png')
                    : require('../../assets/img/layer4/' +
                        lang +
                        '/menu-' +
                        item.id +
                        '.png')" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      lang: "en",
      navList: [
        {
          id: 1,
         
        },
        {
          id: 2,
        },
        {
          id: 3,
        },
        {
          id: 4,
        },
        {
          id: 5,
        }
      ],
      iconIndex: 1,
      boxList: [
        {
          id: 1
        },
        {
          id: 2
        },
        {
          id: 3
        },
        {
          id: 4
        },
        {
          id: 5
        }
      ],
      boxIndex: 1,
      mouseIdx: 1
    };
  },
  watch: {},
  methods: {
    handleIcon(item) {
      this.iconIndex = item.id;
      this.boxIndex = item.id;
    },
    handlePic(item) {
      this.iconIndex = item.id;
      this.boxIndex = item.id;
    },
    handlePicMouse(item) {
      this.mouseIdx = item.id;
    },
    handlePicLeave(item) {
      this.mouseIdx = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer4 {
  .screen-container {
    background: #000;
    position: relative;

    .cnt {
      height: 50vw;
      width: 100%;
      position: relative;
    }

    .layer-box-cnt {
      height: 45vw;
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;

      .sl-box {
        position: relative;
        width: 100%;
        height: 100%;

        .sl-title {
          height: auto;
          width: 682px;
          display: block;
          position: absolute;
          top: 36vw;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }

      .pic-num {
        margin-left: 0.22%;
        transition: all 0.2s ease-in-out;
      }

      .pic-box {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center top;
        position: relative;

        .sl-cnt {
          width: 156px;
          height: auto;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center top;
          position: absolute;
          top: 6vw;
        }
      }

      .pic-box:hover {
        .sl_car {
          background-image: url("../../assets/img/layer4/sl_car_h.png");
        }
      }

      .pic-box1 {
        background-image: url("../../assets/img/layer4/pic-bg-1.png");
      }

      .pic-box2 {
        background-image: url("../../assets/img/layer4/pic-bg-2.png");
      }

      .pic-box3 {
        background-image: url("../../assets/img/layer4/pic-bg-3.png");
      }

      .pic-box4 {
        background-image: url("../../assets/img/layer4/pic-bg-4.png");
      }

      .pic-box5 {
        background-image: url("../../assets/img/layer4/pic-bg-5.png");
      }

      .box-active {
        width: 67%;
        height: 100%;
      }

      .sl-box {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center top;
      }

      .sl-box1 {
        background-image: url("../../assets/img/layer4/sl-1.png");
      }

      .sl-box2 {
        background-image: url("../../assets/img/layer4/sl-2.png");
      }

      .sl-box3 {
        background-image: url("../../assets/img/layer4/sl-3.png");
      }

      .sl-box4 {
        background-image: url("../../assets/img/layer4/sl-4.png");
      }

      .sl-box5 {
        background-image: url("../../assets/img/layer4/sl-5.png");
      }

      .box-unactive {
        width: 8.2%;
        height: 100%;
        position: relative;
        cursor: pointer;

        .sl_car {
          background-image: url("../../assets/img/layer4/sl_car.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center top;
          width: 123px;
          height: 73px;
          bottom: 2vw;
          left: 50%;
          position: absolute;
          transform: translate(-50%);
          cursor: pointer;
        }
      }
    }

    .layer-line-cnt {
      width: 100%;
      // height: 5vw;
      // position: absolute;
      // bottom: 1vw;
      background-image: url("../../assets/img/layer4/left_line.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: left bottom;

      .botton-icon {
        position: relative;
        width: 60%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
      }

      .icon {
        width: 150px;
        height: 50px;
        // margin-top: .6vw;

        img {
          width: 100%;
          height: 100%;
          display: block;
          transition: all 0.5s ease-in-out;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer4.vue